@if (customerServiceInfo) {
    <div class="d-flex flex-column w-100 customer-service mb-4">
        @if (customerServiceInfo.nameSection) {
            <span class="customer-service-title customer-title">{{ customerServiceInfo.nameSection }}</span>
        }
        <div class="customer-information-container">
            @if (customerServiceInfo.email) {
                <div class="d-flex flex-column w-100 customer-email">
                    <span class="d-flex">Email:</span>
                    <a
                        id="customer-service-email"
                        class="mailto-link text-wrap link"
                        [href]="'mailto:' + customerServiceInfo.email | sanitize: 'url'"
                        >{{ customerServiceInfo.email }}</a
                    >
                </div>
            }
            @if (customerServiceInfo.phone) {
                <div class="d-flex flex-column w-100 customer-email">
                    <span class="mat-body-2 pe-2 m-0">Phone:</span>
                    <a
                        id="customer-service-phone"
                        class="mailto-link text-wrap link"
                        [href]="'tel:' + customerServiceInfo.phone | sanitize: 'url'"
                        >{{ customerServiceInfo.phone }}</a
                    >
                </div>
            }
        </div>
    </div>
    @if (customerServiceInfo.operatingHours && customerServiceInfo.operatingHours.length) {
        <div class="d-flex flex-column w-100 customer-service">
            <span class="customer-service-title customer-title"
                >Operating Hours: {{ customerServiceInfo.timeZone || '' }}</span
            >
            <div class="customer-information-container">
                @if (customerServiceInfo.operatingHours) {
                    @for (range of customerServiceInfo.operatingHours; let rangeIndex = $index; track rangeIndex) {
                        <div class="d-flex flex-column w-100 customer-email">
                            <span class="d-flex">{{ range.days }}:</span>
                            <span class="d-flex">{{ range.schedule }}</span>
                        </div>
                    }
                }
            </div>
        </div>
    }
}
